import * as React from 'react';
import { Field, FormSection, InjectedFormProps, reduxForm } from 'redux-form';

import { FormsLocale } from './forms.locale';
import { required, email, phone } from '../../../containers/Validator/validator';
import FormComponent from '../../Form/Form';
import Input from '../../Input/Input';
import TextArea from '../../Input/TextArea';
import Button from '../../Button/Button';
import ThankYou from '../../Form/ThankYou';

export interface FormData {
  contact: {
    fullName: string;
    company: string;
    emailAddress: string;
    phoneNumber: string;
  };
  message: string;
}

interface OwnProps {
  locale: FormsLocale;
}

interface SupportFormProps extends InjectedFormProps<FormData, OwnProps>, OwnProps {}

const SupportForm: React.SFC<SupportFormProps> = ({
  locale,
  submitting,
  handleSubmit,
  error,
  submitSucceeded,
}) => (
  <FormComponent title={locale.supportTitle} loading={submitting} error={error}>
    {submitSucceeded ? (
      <ThankYou thanksText={locale.supportThankYou} />
    ) : (
      <form onSubmit={handleSubmit}>
        <FormSection name="contact">
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="fullName"
                component={Input}
                props={{ label: locale.name, type: 'text' }}
                validate={required}
              />
            </div>

            <div className="col-12 col-md-6 mb-3">
              <Field
                name="company"
                component={Input}
                props={{ label: locale.company, type: 'text' }}
                validate={required}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <Field
                name="emailAddress"
                component={Input}
                props={{ label: locale.email, type: 'email' }}
                validate={[required, email]}
              />
            </div>

            <div className="col-12 col-md-6 mb-3">
              <Field
                name="phoneNumber"
                component={Input}
                props={{ label: locale.phone, type: 'tel' }}
                validate={[required, phone]}
              />
            </div>
          </div>
        </FormSection>

        <div className="row">
          <div className="col-12 mb-3">
            <Field
              name="message"
              component={TextArea}
              props={{
                label: locale.message,
                placeholder: '',
              }}
              validate={required}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <Button type="submit">{locale.confirm}</Button>
        </div>
      </form>
    )}
  </FormComponent>
);

export default reduxForm<FormData, OwnProps>({
  form: 'contactSupport',
  destroyOnUnmount: false,
  initialValues: {
    contact: {
      fullName: '',
      company: '',
      emailAddress: '',
      phoneNumber: '',
    },
    message: '',
  },
})(SupportForm);



// WEBPACK FOOTER //
// /www/client/src/components/ContactPage/Forms/SupportForm.tsx